// How one copy of a title is told from another, in the few words a button or a row has for it.
// Written once, because a version that reads "1080p · 12 GB · MP4" in the picker and something
// else in the list beside it is two descriptions of the same file.

import type { MediaSourceSummary } from '../../api/types';
import { containerName, formatBitrate } from '../player/streamText';
import { formatSize } from './formatSize';

/// The name on its own. The path is the server's business and is usually too long to read.
export function fileName(path: string): string {
  return path.split(/[\\/]/).pop() ?? path;
}

/// Picture, size, rate and wrapping, in the order somebody weighs them. The size is left out
/// where there is no room for it - a button that names the copy in use is not a list.
export function describeVersion(
  version: MediaSourceSummary,
  t: (key: string) => string,
  { withSize = true }: { withSize?: boolean } = {},
): string {
  const video = version.streams.find((stream) => stream.kind === 'Video');

  const parts = [
    video?.height ? `${video.height}p` : undefined,
    withSize ? formatSize(version.sizeInBytes) : undefined,
    version.bitrate ? formatBitrate(version.bitrate) : undefined,
    containerName(version.container),
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' · ') : t('item.version');
}
